import { Component, OnInit, Input, ContentChild, Injector } from '@angular/core';
import { FormControlName, FormControlDirective, NgControl } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'mm-form-item',
  templateUrl: './form-item.component.html',
  styleUrls: ['./form-item.component.scss']
})
export class FormItemComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  @Input() nzRequired: boolean = false;

  @Input()
  labelWidth = "100px"

  label$ = new BehaviorSubject<string>(undefined);
  @Input()
  set label(_: string) {
    this.label$.next(_);
  }

  get label() {
    return this.label$.value;
  }

  @Input()
  showLabel: boolean = true;



  @ContentChild(NgControl, { static: false })
  validateControl?: NgControl;

}
